<template>
  <div class="container">
    <content-header :data="[{text: '文章一览', path: '/article/list'},{text:(curObj.id ? '修改':'添加')+'文章', path: ''}]"></content-header>
    <div class="content">
      <el-form :model="curObj" :rules="curObjRules" ref="curObjForm" label-position="right" label-width="0px">
        <el-form-item prop="title" label="标题" :label-width="formLabelWidth">
          <el-input name="title" v-model="curObj.title" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item prop="category_id" label="分类" :label-width="formLabelWidth">
          <el-select v-model="curObj.category_id" clearable value-key="id" placeholder="请选择类型">
            <el-option
              v-for="item in categoryIds"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="cover_url" label="题图" :label-width="formLabelWidth">
          <el-upload
            class="avatar-uploader"
            :headers = "uploadHeader"
            :action="uploadUrl"
            :show-file-list="false"
            :on-success="uploadPhotoSuccess"
            :before-upload="beforePhotoUpload"
            :on-error="uploadError">
            <img v-if="curObj.cover_url" :src="domainPic + curObj.cover_url" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item prop="content" label="内容" :label-width="formLabelWidth">
          <ky-editor v-model="curObj.content"
            ref="myQuillEditor">
          </ky-editor>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth">
          <el-button @click="cancelHandle">取 消</el-button>
          <el-button type="primary" @click="confirmHandle">确 定</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script type="text/babel">
  import constants from 'config/constants'
  import sessionstorage from 'utils/sessionstorage'
  import urls from 'config/urls'
  import ArticleModel from 'models/article'
  import KyEditor from 'components/KyEditor'

  export default {
    components: {
      KyEditor,
    },
    data () {
      return {
        domainPic: constants.basic.domain_pic,
        uploadUrl: constants.basic.domain + urls.file.upload,
        editorOption: {
          placeholder: '请输入内容……',
        },
        uploadHeader: {},
        keywords: '',
        tableData: [],
        isObjShow: false,
        categoryIds: [],
        curObj: {
          id: '',
          title: '',
          category_id: '',
          cover_url: '',
          content: '',
        },
        formLabelWidth: '120px',
        curObjRules: {
          title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        },
        curPage: 1,
        pageSize: 10,
        total: 0
      }
    },
    created () {
      sessionstorage.getItem('token').then(token => {
        if (!token) return
        this.uploadHeader = {Authorization: 'Bearer ' + token}
      })
      //
      this.curObj.id = this.$route.query.id
      console.log(this.curObj.id)
      if (this.curObj.id) {
        ArticleModel.get({
          id: this.curObj.id
        }).then(res => {
          this.curObj = res
          console.log(this.curObj)
        })
      }
      ArticleModel.findCategory({curPage: 1, pageSize: 1000}).then(res => {
        // console.log(res)
        this.categoryIds = res.item_list
      })
    },
    methods: {
      uploadError (err, file, fileList) {
        console.log(err)
      },
      uploadPhotoSuccess (response, file, fileList) {
        this.curObj.cover_url = response
      },
      beforePhotoUpload (file) {
        const isPic = (file.type === 'image/jpeg' || file.type === 'image/png')
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isPic) {
          this.$message.error('上传图片只能是 JPG/PNG 格式!')
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!')
        }
        return isPic && isLt2M
      },
      //
      cancelHandle () {
        this.$router.go(-1)
      },
      confirmHandle () {
        this.$refs.curObjForm.validate(valid => {
          if (!valid) return
          if (this.curObj.id) return this.editHandle()
          this.newHandle()
        })
      },
      newHandle () {
        ArticleModel.create(this.curObj).then(() => {
          this.$router.go(-1)
          this.$message({ message: '添加成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      editHandle () {
        ArticleModel.update(this.curObj).then(() => {
          this.$router.go(-1)
          this.$message({ message: '更新成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    padding: 20px
    font-size: 14px
    .el-input
      width: 50%
    .textarea
      width: 80%
    .avatar-uploader
        border: 1px dashed #d9d9d9
        border-radius: 6px
        cursor: pointer
        position: relative
        overflow: hidden
        width: 180px
        &:hover
          border-color: #409EFF
        .avatar-uploader-icon
          font-size: 28px
          color: #8c939d
          width: 178px
          height: 178px
          line-height: 178px
          text-align: center
        .avatar
          width: 178px
          height: 178px
          display: block

</style>



// WEBPACK FOOTER //
// src/views/ArticleNew.vue